// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"4e51642b","545":"1d307447","551":"a22a53b6","605":"a680a1e4","662":"22689114","766":"5ed7da84"}[chunkId] + ".chunk.js";
};